import PermIdentity from '@material-ui/icons/PermIdentity';
import {TradeMarksList} from "./TradeMarksList";
import {TradeMarksCreate} from "./TradeMarksCreate";
import {TradeMarksEdit} from "./TradeMarksEdit";
// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: TradeMarksList,
    create: TradeMarksCreate,
    edit: TradeMarksEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;